import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotOut,
  types,
} from "mobx-state-tree";
import {
  createCreateAllowedDomainStore,
  CreateAllowedDomainStore,
} from "./CreateAllowedDomainStore";
import {
  createUpdateAllowedDomainStore,
  UpdateAllowedDomainStore,
} from "./UpdateAllowedDomainStore";
import {
  createDeleteAllowedDomainStore,
  DeleteAllowedDomainStore,
} from "./DeleteAllowedDomainStore";
import {
  BoundedNameModel,
  createBoundedNameModel,
} from "../../models/BoundedNameModel";
import { EMPTY_CHARACTER } from "@pulse/shared-components";

const getInitialState = (): SnapshotOut<typeof AllowedDomainDetailsStore> => ({
  domainId: EMPTY_CHARACTER,
  domainName: createBoundedNameModel(),
  domain: createBoundedNameModel(),
  createAllowedDomainStore: createCreateAllowedDomainStore(),
  updateAllowedDomainStore: createUpdateAllowedDomainStore(),
  deleteAllowedDomainStore: createDeleteAllowedDomainStore(),
});

export const AllowedDomainDetailsStore = types
  .model("AllowedDomainDetailsStore", {
    domainId: types.string,
    domainName: BoundedNameModel,
    domain: BoundedNameModel,
    createAllowedDomainStore: CreateAllowedDomainStore,
    updateAllowedDomainStore: UpdateAllowedDomainStore,
    deleteAllowedDomainStore: DeleteAllowedDomainStore,
  })
  .actions((store) => ({
    setAllowedDomain: (
      domainId: string,
      domainName: string,
      domain: string,
    ): void => {
      store.domainId = domainId;
      store.domainName.setName(domainName);
      store.domain.validationError = undefined;
      store.domain.setName(domain);
      store.updateAllowedDomainStore.setDomainId(domainId);
      store.updateAllowedDomainStore.domainName.setName(domainName);
      store.updateAllowedDomainStore.domain.setName(domain);
    },
    resetStore: (): void => {
      const { domainId, domainName, domain, ...nestedStores } =
        getInitialState();
      applySnapshot(store, {
        ...getSnapshot(store),
        ...nestedStores,
        domainId,
        domainName,
        domain,
      });
    },
  }));

export const createAllowedDomainDetailsStore = (): Instance<
  typeof AllowedDomainDetailsStore
> => AllowedDomainDetailsStore.create(getInitialState());
